import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { CTAButton } from "./CTAButton";

const links = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/areas", label: "Areas We Serve" },
  { to: "/owner-faq", label: "Owner FAQ" },
  { to: "/resident-faq", label: "Resident FAQ" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "border-border bg-background/70 backdrop-blur-xl" : "border-transparent bg-background/40 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src="/logo.png" alt="Cummings & Co. Property Management" className="h-11 w-auto lg:h-12" />
        </Link>

        <nav className="hidden items-center gap-7 xl:flex">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`link-underline text-sm font-medium transition-colors ${
                location.pathname === l.to ? "text-accent" : "text-foreground/80 hover:text-foreground"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 xl:flex">
          <CTAButton to="/rental-analysis" variant="accent" testid="nav-rental-analysis-btn" className="px-5 py-2.5 text-xs">
            What's My Rental Worth?
          </CTAButton>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="xl:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-border bg-background xl:hidden">
          <div className="flex flex-col px-6 py-4">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="border-b border-border py-3 text-sm font-medium" data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </Link>
            ))}
            <CTAButton to="/rental-analysis" variant="accent" className="mt-4 justify-center" testid="mobile-nav-rental-btn">
              What's My Rental Worth?
            </CTAButton>
          </div>
        </div>
      )}
    </header>
  );
};
